import styled from 'styled-components';

export const Button = styled.button<{ currentFollowing: boolean }>`
  display: inline;
  font-weight: 600;
  color: ${({ currentFollowing }) => (currentFollowing ? '' : '#db1f72')};
`;
